// Stub for removed template hook — keeps NavCollapse working

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function useMenuCollapse(..._args: unknown[]) {
  return {
    isOpen: false,
    toggleOpen: () => {},
    handleClose: () => {}
  };
}
